const initialState = {
  theme: '', // 换肤主题色
  userInfo: {} // 用户信息
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_THEME':
    case 'SET_USERINFO':
    default:
      return {
        ...state,
        ...action.payload
      };
  }
};
